import { render, staticRenderFns } from "./unit_edit_link_area.vue?vue&type=template&id=67e917c0&scoped=true"
import script from "./unit_edit_link_area.vue?vue&type=script&lang=js"
export * from "./unit_edit_link_area.vue?vue&type=script&lang=js"
import style0 from "./unit_edit_link_area.vue?vue&type=style&index=0&id=67e917c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e917c0",
  null
  
)

export default component.exports